import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InitialConfigService } from 'src/app/services/inital-config.service';


@Component({
  selector: 'page-login-confirm-rescue-password',
  templateUrl: 'login-confirm-rescue-password.html'
})
export class LoginConfirmRescuePasswordPage implements OnInit {
  public username: any;
  public param: { value: any };
  logo: any;
  userData: any;

  constructor(public router: Router, public initialConfig: InitialConfigService) {
    this.username = this.router.getCurrentNavigation().extras.state.username;
    this.userData = this.router.getCurrentNavigation().extras.state.userData;
  }

  ngOnInit() {
    this.param = { value: this.username };
  }

  public backLoginStepOne() {
    this.router.navigate([`/login/first`], { state: { userData: this.userData } });
  }
}
